/**
 * History Tab Component
 *
 * PE-771: Displays complete audit trail for any record using ActivityTab.
 * Shows creation, updates, status changes, relationships, and all other changes.
 *
 * This is a wrapper around ActivityTab - both show the same audit data
 * from activityLogService.ts for consistency.
 */

import React from 'react';
import { ActivityTab } from '../tabs/ActivityTab';

interface HistoryTabProps {
  /** Record ID to show history for */
  recordId: string;
  /** Object type (e.g., 'Client__c', 'Task__c') */
  objectType: string;
  /** Optional record name for display */
  recordName?: string;
}

/**
 * HistoryTab - Displays complete audit trail for a record.
 *
 * Wraps ActivityTab component which provides:
 * - Timeline display with color-coded actions
 * - Field-level change tracking with old/new values
 * - User attribution and timestamps
 * - Expandable entries for detailed changes
 * - Filter by action type
 */
export const HistoryTab: React.FC<HistoryTabProps> = ({
  recordId,
  objectType,
  recordName,
}) => {
  // HistoryTab reuses ActivityTab - both show complete audit trail
  // This ensures consistent display across the application
  return (
    <ActivityTab
      recordId={recordId}
      objectType={objectType}
      recordName={recordName}
    />
  );
};

export default HistoryTab;
